import {useMemo} from 'react';

import {DateFormat, format, isValidDate} from '../../../../util/date';
import {LogLabelFilterOption} from '../LogLabelFilter';
import {type LogLineData} from '../LogLineRenderer';

function stripAnsiCodes(text: string): string {
  // eslint-disable-next-line no-control-regex
  return text.replace(/\u001b\[[0-9;]*m/g, '');
}

/**
 * useLogsFormattedForCopy formats log lines for clipboard copying, including
 * timestamps and labels based on visibility settings. It also strips ANSI color
 * codes for plain text output.
 */
export function useLogsFormattedForCopy(
  lines: readonly LogLineData[],
  labels: readonly LogLabelFilterOption[],
  isTimestampVisible: boolean
) {
  return useMemo(() => {
    return lines
      .map(line => {
        const parts = [] as string[];

        if (isTimestampVisible && isValidDate(new Date(line.timestamp))) {
          parts.push(
            format(
              new Date(line.timestamp),
              DateFormat.YYYY_MM_DD_HH_MM_SS_DASHES
            )
          );
        }

        if (labels.length > 0 && line.label) {
          parts.push(`[${line.label}]`);
        }

        parts.push(stripAnsiCodes(line.line));

        return parts.join(' ');
      })
      .join('\n');
  }, [lines, labels, isTimestampVisible]);
}
